import { useConnectionState } from '@livekit/components-react';
import { ConnectionState } from 'livekit-client';

import { useStrings } from '../i18n/context';

/** "Reconnecting…" while LiveKit restores the connection (the prefab toast is English-only). */
export function ReconnectingBanner() {
  const strings = useStrings();
  const state = useConnectionState();
  if (state !== ConnectionState.Reconnecting && state !== ConnectionState.SignalReconnecting) return null;
  // <output> carries the status role: screen readers announce it politely.
  return <output className="banner">{strings.reconnecting}</output>;
}
